module.exports = __webpack_public_path__ + "img/shuye.8d755c56.svg";